import axios from "axios";

class Service {
  constructor() {
    this.baseUrl = "https://api.rekhacollection.in/v1/api";

    // Define token and headers once
    this.getConfig = () => {
      const token = localStorage.getItem("authToken");
      return {
        headers: {
          Authorization: token,
        },
      };
    };
  }

  // Banner APIs
  getAllBanners = async () => {
    return await axios.get(`${this.baseUrl}/customer/getAllBanners`);
  };

  getSpotLightProducts = async () => {
    return await axios.get(`${this.baseUrl}/customer/getSportlightProducts`);
  };

  // Profile APIs
  getProfile = async () => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/customer/getProfile`, config);
  };

  updateProfile = async (payload) => {
    const config = this.getConfig();
    return await axios.put(`${this.baseUrl}/customer/profileUpdate`,payload , config);
  };

  // Product APIs
  getProductByCategory = async (category = "Cargo") => {
    return await axios.get(`${this.baseUrl}/customer/getProductsByCategory`, {
      params: { category },
    });
  };

  getCuponDetails = async () => {
    return await axios.get(`${this.baseUrl}/coupon/customer/getAll`);
  };

  getAllCategory = async () => {
    return await axios.get(`${this.baseUrl}/customer/categories`);
  };

  getAllProducts = async (filters) => {
    const response = await axios.get(
      `${this.baseUrl}/customer/getAllProducts`,
      {
        params: filters,
      }
    );
    return response;
  };

  getAllComboProducts = async (filters) => {
    const response = await axios.get(`${this.baseUrl}/customer/getAllCombos`, {
      params: filters,
    });
    return response;
  };

  getMostWantedProducts = async (filters) => {
    const response = await axios.get(
      `${this.baseUrl}/customer/getAllProductsMostWantand`,
      {
        params: filters,
      }
    );
    return response;
  };

  getNewAdditionProducts = async (filters) => {
    const response = await axios.get(
      `${this.baseUrl}/customer/getAllProductsNewAdditions`,
      {
        params: filters,
      }
    );
    return response;
  };

  getProductDetailsById = async (id) => {
    return await axios.get(`${this.baseUrl}/customer/products/${id}`);
  };

  getSimilarProduct = async (category) => {
    return await axios.get(
      `${this.baseUrl}/customer/getSimilarProductsByCategory`,
      {
        params: { category },
      }
    );
  };

  customCreateCart = async (payload) => {
  console.log("Sending payload to backend:", payload);
  
  const config = this.getConfig();
  return await axios.post(
    `${this.baseUrl}/customTShirtPrint/create`,
    payload, // Send as JSON directly
    {
      ...config,
      headers: { 
        ...config.headers, 
        "Content-Type": "application/json" 
      },
    }
  );
};

  createCart = async (payload) => {
    const config = this.getConfig();
    return await axios.post(`${this.baseUrl}/createCart`, payload, config);
  };

  getAllCartData = async () => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/getCustomercart`, config);
  };

  getCartCount = async () => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/getCartCount`, config);
  };

  removeItemFromCart = async (payload) => {
    const config = this.getConfig();
    return await axios.post(`${this.baseUrl}/removeCartItem`, payload, config);
  };

  // Address APIs
  getAllAddress = async () => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/getAddresses`, config);
  };

  deleteAddress = async (id) => {
    const config = this.getConfig();
    return await axios.delete(`${this.baseUrl}/deleteAddress/${id}`, config);
  };

  saveAddress = async (payload) => {
    const config = this.getConfig();
    return await axios.post(`${this.baseUrl}/createAddress`, payload, config);
  };

  getAddressById = async (id) => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/getAddressById/${id}`, config);
  };

  updateAddress = async (payload, id) => {
    const config = this.getConfig();
    return await axios.put(
      `${this.baseUrl}/updateAddress/${id}`,
      payload,
      config
    );
  };

  //Update Shipping Address
  updateShippingAddress = async (payload) => {
    const config = this.getConfig();
    return await axios.put(`${this.baseUrl}/update-shipping-address`, payload, config);
    };

  // OTP APIs
  generateOtp = async (payload) => {
    return await axios.post(`${this.baseUrl}/customer/generateOtp`, payload);
  };

  verifyOtp = async (payload) => {
    return await axios.post(`${this.baseUrl}/customer/verifyOtp`, payload);
  };

  // Purchase APIs
  initiatePurchase = async (payload) => {
    const config = this.getConfig();
    return await axios.post(`${this.baseUrl}/userProductBuy`, payload, config);
  };

  verifyPurchase = async (payload) => {
    const config = this.getConfig();
    return await axios.post(
      `${this.baseUrl}/userProductVerify`,
      payload,
      config
    );
  };

  getFilterOption = async () => {
    try {
      const response = await axios.get(
        `${this.baseUrl}/customer/getFilterOptions`
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  };

  //get all orders
  getAllOrders = async () => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/orderStatus`, config);
  };

  //all product details
  getAllProductDetails = async (id) => {
    const config = this.getConfig();
    return await axios.get(`${this.baseUrl}/order/${id}`, config);
  };

  // Update cart API call
  updateCartService = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.patch(
        `${this.baseUrl}/cart/updateCart`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      console.error("Error updating cart:", error);
      throw error;
    }
  };

  //Add to Wiselist
  addOrUpdateWishlistService = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/addOrUpdateWishlist/wishlist`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  //wishlist show
  getWishlistService = async () => {
    const config = this.getConfig();
    try {
      const response = await axios.get(
        `${this.baseUrl}/getWishlist/wishlist`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  //get all product for the search preference here
  getAllProductSearchService = async () => {
    const config = this.getConfig();
    try {
      const response = await axios.get(
        `${this.baseUrl}/customer/productsOverview`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Searching
  searchProducts = async (searchQuery) => {
    const response = await axios.post(
      `${this.baseUrl}/customer/searchProducts`,
      {},
      {
        params: { query: searchQuery },
      }
    );
    return response.data;
  };

  //remove from wishlist
  removeWishlistService = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.delete(
        `${this.baseUrl}/removeFromWishlist/wishlist`,
        {
          ...config,
          data: payload,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  //pin chack
  pinChackService = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/check-serviceability`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  applyCouponService = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/applyCoupon`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.meta?.message || "Failed to apply coupon";
    }
  };

  applyCouponWithCode = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/applyCouponWithCode`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.meta?.message || "Failed to apply coupon";
    }
  };

  //newsletter service
  subscribeToNewsletter = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/subscribeToNewsletter`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data?.meta?.message ||
        "Failed to subscribe to newsletter"
      );
    }
  };




  GoogleLogin = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/customer/googleLogin`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Update order (return / replacement / general)
  updateOrder = async (orderId, payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.put(
        `${this.baseUrl}/order/update/${orderId}`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Return request - initiates return and creates Razorpay order for processing fee
  orderReturnRequest = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/orderReturnRequest`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Return verify - verifies Razorpay payment for return processing fee
  orderReturnVerify = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/orderReturnVerify`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

    // Return request - initiates return and creates Razorpay order for processing fee
  orderReplaceRequest = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/orderReplaceRequest`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };


  // Replace verify - verifies Razorpay payment for replacement processing fee
  orderReplaceVerify = async (payload) => {
    const config = this.getConfig();
    try {
      const response = await axios.post(
        `${this.baseUrl}/orderReplaceVerify`,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

const serviceInstance = new Service();
export default serviceInstance;
